import { Tooltip } from "bootstrap";
import { ComponentOptions } from "bootstrap/js/dist/base-component";
import { ReactNode, useEffect, useRef } from "react";

export const ConditionalTooltip = (props: {
    children: ReactNode;
    text: string;
    show: boolean;
    placement?: "top" | "right" | "bottom" | "left";
    forceShow?: boolean;
    className?: string;
}) => {
    const { children, text, show, placement = "bottom", forceShow, className } = props;

    const divRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (divRef.current) {
            const options: ComponentOptions = {
                title: text,
                placement,
                trigger: forceShow ? "manual" : "hover",
            };

            const tooltip = Tooltip.getOrCreateInstance(divRef.current, options);

            if (show) {
                if (forceShow) {
                    tooltip.show();
                } else {
                    tooltip.enable();
                }
            } else {
                if (forceShow) {
                    tooltip.hide();
                } else {
                    tooltip.disable();
                }
            }

            return () => {
                tooltip.hide();
            };
        }

        return () => null;
    }, [placement, show, text, forceShow]);

    // update content when text changes
    useEffect(() => {
        if (divRef.current && text) {
            const tooltip = Tooltip.getOrCreateInstance(divRef.current);
            tooltip?.setContent({ ".tooltip-inner": text });
        }
    }, [text]);

    return (
        <div className={className} ref={divRef}>
            {children}
        </div>
    );
};
